import './styles.scss';

import { Spin } from 'antd';
import React, { ReactNode, Suspense } from 'react';

export interface ILoadingProps {
  children: ReactNode;
}

export const Loading: React.FC<ILoadingProps> = ({ children }: ILoadingProps) => (
  <Suspense
    fallback={<Spin spinning size="large" className="loading-spinner" />}
    children={children}
  />
);
